import { Fragment } from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Divider,
    InputAdornment
} from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import { H5, Body2 } from '../../../themes/typography'

export default function AttendeeForm({
    selectedTickets = [],
    formik
}) {
    // Flatten attendees across all tickets to calculate global attendeeIndex
    let globalIndex = 0

    return (
        <div className="ticket-purchased-attendee-container">

            <H5>
                Fill Attendee Details
            </H5>

            {selectedTickets.map((ticket, ticketIndex) => {

                // Calculate attendee count
                const attendeeCount = ticket.isGroupTicket
                    ? ticket.quantity * ticket.groupTicketAttendees
                    : ticket.quantity;

                return (
                    <Fragment key={ticket.ticketId}>
                        <div
                            className="each-attendee-ticket-container"
                        >
                            <div className='attendee-ticket-title-desc'>
                                <div className='attendee-ticket-desc-container'>
                                    <H5 color="var(--secondary-color)">
                                        {ticket.name} x {ticket.quantity}
                                    </H5>
                                </div>
                                <div className='attendee-ticket-desc-container'>
                                    <Body2 fontWeight={300}>
                                        {ticket.description}
                                    </Body2>
                                </div>
                            </div>

                            <div className='each-attendee-detail-form-listing'>
                                {Array.from({ length: attendeeCount }).map((_, i) => {
                                    const attendeeIndex = globalIndex
                                    globalIndex++

                                    return (
                                        <Accordion
                                            key={`${ticket.ticketId}-${i}`}
                                            defaultExpanded={i === 0}
                                            sx={{
                                                alignSelf: 'stretch',
                                                fontWeight: 700,
                                                // background: 'var(--gradient-blue)',
                                                background: 'transparent',
                                                color: 'var(--quaternary-color)',
                                                borderRadius: '1rem !important',
                                                boxShadow: 'none',
                                                textAlign: 'justify',
                                                '& .MuiAccordionSummary-root': {
                                                    minHeight: '56px'
                                                },
                                                '& .MuiAccordionSummary-expandIconWrapper': {
                                                    color: 'var(--quaternary-color)'
                                                }
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <H5>
                                                    Attendee {i + 1}
                                                </H5>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ paddingTop: '0px' }}>
                                                <div className='attendee-detail-form-input-fields'>
                                                    <form id='attendee-ticket-form'>

                                                        <div className="attendee-input-field-container">
                                                            <TextField
                                                                label="Name"
                                                                name={`attendees[${attendeeIndex}].name`}
                                                                value={formik.values.attendees[attendeeIndex]?.name || ''}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                error={formik.touched.attendees?.[attendeeIndex]?.name && Boolean(formik.errors.attendees?.[attendeeIndex]?.name)}
                                                                helperText={formik.touched.attendees?.[attendeeIndex]?.name && formik.errors.attendees?.[attendeeIndex]?.name}
                                                            />
                                                        </div>

                                                        <div className="attendee-input-field-container">
                                                            <TextField
                                                                label="Email ID"
                                                                name={`attendees[${attendeeIndex}].email`}
                                                                value={formik.values.attendees[attendeeIndex]?.email || ''}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                error={formik.touched.attendees?.[attendeeIndex]?.email && Boolean(formik.errors.attendees?.[attendeeIndex]?.email)}
                                                                helperText={formik.touched.attendees?.[attendeeIndex]?.email && formik.errors.attendees?.[attendeeIndex]?.email}
                                                            />
                                                        </div>

                                                        <div className="attendee-input-field-container">
                                                            <TextField
                                                                label="Phone"
                                                                name={`attendees[${attendeeIndex}].phone`}
                                                                value={formik.values.attendees[attendeeIndex]?.phone || ''}
                                                                onChange={(e) => {
                                                                    const numericValue = e.target.value.replace(/\D/g, '');
                                                                    formik.setFieldValue(`attendees[${attendeeIndex}].phone`, numericValue);
                                                                }}
                                                                onBlur={formik.handleBlur}
                                                                error={formik.touched.attendees?.[attendeeIndex]?.phone && Boolean(formik.errors.attendees?.[attendeeIndex]?.phone)}
                                                                helperText={formik.touched.attendees?.[attendeeIndex]?.phone && formik.errors.attendees?.[attendeeIndex]?.phone}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment
                                                                            position="start"
                                                                        >
                                                                            +91
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                                inputProps={{
                                                                    inputMode: 'numeric', // shows numeric keypad on mobile
                                                                    pattern: '[0-9]*',    // restricts to numbers
                                                                    maxLength: 10,        // optional: limit to 10 digits
                                                                }}
                                                            />
                                                        </div>
                                                    </form>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    )
                                })}
                            </div>

                        </div>
                        {ticketIndex < selectedTickets.length - 1 && (
                            <Divider
                                sx={{
                                    borderColor: 'var(--divider-color)',
                                    alignSelf: 'stretch',
                                    my: 2
                                }}
                            />
                        )}
                    </Fragment>
                )
            })}

            <div className="each-attendee-ticket-container"></div>

        </div>
    )
}

/**
function EachAttendeeAccordion() {
    return (
        <Accordion
            defaultExpanded
            sx={{
                alignSelf: 'stretch',
                fontWeight: 700,
                background: 'var(--gradient-blue)',
                color: 'var(--quaternary-color)',
                borderRadius: '1rem !important',
                boxShadow: 'none',
                textAlign: 'justify',
                '& .MuiAccordionSummary-root': {
                    minHeight: '56px'
                },
                '& .MuiAccordionSummary-expandIconWrapper': {
                    color: 'var(--quaternary-color)'
                }
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <H5>
                    Attendee Name
                </H5>
            </AccordionSummary>
            <AccordionDetails sx={{ paddingTop: '0px' }}>
                <div className='attendee-detail-form-input-fields'>
                    <form id='attendee-ticket-form'>

                        <div className="attendee-input-field-container">
                            <TextField
                                label="Name"
                            />
                        </div>

                        <div className="attendee-input-field-container">
                            <TextField
                                label="Email ID"
                            />
                        </div>

                        <div className="attendee-input-field-container">
                            <TextField
                                label="Phone"
                            />
                        </div>
                    </form>
                </div>
            </AccordionDetails>
        </Accordion>
    )
}
*/